import L from 'leaflet';
import 'leaflet-geometryutil';

export function projectPointWithDistanceArray(map, latlng, routeIndex) {
  const { latlngs, cum } = routeIndex;
  if (!latlngs || latlngs.length < 2) return null;

  let best = { minD: Infinity, snapped: null, segIdx: -1 };

  for (let i = 1; i < latlngs.length; i++) {
    const A = latlngs[i - 1];
    const B = latlngs[i];
    const d = L.GeometryUtil.distanceSegment(map, latlng, A, B);
    if (d < best.minD) {
      best.minD = d;
      best.snapped = L.GeometryUtil.closestOnSegment(map, latlng, A, B);
      best.segIdx = i;
    }
  }

  if (!best.snapped) return null;
  const i = best.segIdx;
  const distanceFromStart = cum[i - 1] + latlngs[i - 1].distanceTo(best.snapped);
  return { snapped: best.snapped, distanceFromStart, offset: best.minD };
}

export function computeDeviceDistanceOnOdcinki(map, odcinki, device) {
  if (!map || typeof map.distance !== 'function' || !device || !odcinki?.length)
    return 'Off-Track';

  const deviceLL = L.latLng(device.latitude, device.longitude);
  const thresholdMeters = 30;
  const padDeg = thresholdMeters / 111000;
  let best = { route: null, proj: null, dist: Infinity };

  for (const o of odcinki) {
    if (!o.bounds?.pad(padDeg).contains(deviceLL)) continue;
    if (!o.routeIndex) continue;

    const proj = projectPointWithDistanceArray(map, deviceLL, o.routeIndex);
    if (!proj) continue;
    if (proj.offset < best.dist) {
      best = { route: o, proj, dist: proj.offset };
    }
  }

  if (!best.proj || best.dist > thresholdMeters) return 'Off-Track';

  const km = (best.proj.distanceFromStart / 1000).toFixed(2);
  return km;
}

export function computeOnStageInfo(map, odcinki, device, thresholdMeters = 30) {
  if (!map || !device || !odcinki?.length) return { onStage: false };

  const deviceLL = L.latLng(device.latitude, device.longitude);
  const padDeg = thresholdMeters / 111000;
  let best = { route: null, proj: null, dist: Infinity };

  for (const o of odcinki) {
    if (!o.bounds?.pad(padDeg).contains(deviceLL)) continue;
    if (!o.routeIndex) continue;

    let bestSeg = { minD: Infinity, snapped: null, segIdx: -1 };
    const { latlngs, cum } = o.routeIndex;
    for (let i = 1; i < latlngs.length; i++) {
      const A = latlngs[i - 1], B = latlngs[i];
      const d = L.GeometryUtil.distanceSegment(map, deviceLL, A, B);
      if (d < bestSeg.minD) {
        bestSeg.minD = d;
        bestSeg.snapped = L.GeometryUtil.closestOnSegment(map, deviceLL, A, B);
        bestSeg.segIdx = i;
      }
    }
    if (!bestSeg.snapped) continue;
    const i = bestSeg.segIdx;
    const distanceFromStart = cum[i - 1] + latlngs[i - 1].distanceTo(bestSeg.snapped);

    const proj = { snapped: bestSeg.snapped, offset: bestSeg.minD, distanceFromStart };
    if (proj.offset < best.dist) best = { route: o, proj, dist: proj.offset };
  }

  if (!best.proj || best.dist > thresholdMeters) return { onStage: false };

  return {
    onStage: true,
    routeName: best.route.name,
    distance_m: best.proj.distanceFromStart,
    offset_m: best.proj.offset,
  };
}
